import { privateRoutesPath } from "../Routes";
import { permissionList } from "./constant";

const handleCheckViewManage = (permission, initialState) => {
    
    switch(permission) {
        
        case permissionList?.DASHBOARD_VIEW:
             initialState.isDashboradView = true;
             return initialState;
    
        case permissionList?.LEAD_VIEW: 
            initialState.isLeadView = true;
            return initialState;
            
        case permissionList?.INVOICE_VIEW: 
            initialState.isInvoiceView= true
            return initialState;
            
        case permissionList?.MERCHANT_VIEW: 
        
            initialState.isVendorView = true;
            return initialState;
            
        case permissionList?.PRODUCT_VIEW: 
            initialState.isProductView = true;
            return initialState;
            
        case permissionList?.ORDER_VIEW: 
            initialState.isOrderView =true
            return initialState; 
            
        case permissionList?.CONFIGURATION_VIEW: 
            initialState.isConfigurationView = true;
            return initialState;
            
        case permissionList?.CUSTOMER_VIEW: 
            initialState.isCustomerView = true;
            return initialState;
            
        case permissionList?.DASHBOARD_MANAGE: 
            initialState.isdashboardManage = true;
            initialState.isDashboradView = true;
            
            return initialState;
            
        case permissionList?.LEAD_MANAGE: 
            initialState.isLeadManage = true;
            initialState.isLeadView = true;
            
            return initialState;

        case permissionList?.ALL_LEAD_MANAGE: 
            initialState.isAllLeadManage = true;
            initialState.isLeadManage = true;
            initialState.isLeadView = true;
            
            return initialState;
            

        case permissionList?.INVOICE_MANAGE: 
            initialState.isInvoiceManage = true;
            initialState.isInvoiceView = true;
            
            return initialState;
            
        case permissionList?.ALL_INVOICE_MANAGE: 
            initialState.isAllInvoiceManage = true;
            initialState.isInvoiceManage = true;
            initialState.isInvoiceView = true;
            
            return initialState;
            
        case permissionList?.MERCHANT_MANAGE: 
            initialState.isVendorManage= true;
            initialState.isVendorView= true
            
            return initialState;

        case permissionList?.PRODUCT_MANAGE: 
            initialState.isProductManage= true;
            initialState.isProductView= true;
            
            return initialState;

        case permissionList?.ORDER_MANAGE: 
            initialState.isOrderManage= true;
            initialState.isOrderView= true;
            
            return initialState;
            
        case permissionList?.ALL_ORDER_MANAGE: 
            initialState.isAllOrderManage= true;
            initialState.isOrderManage= true;
            initialState.isOrderView= true;
            
            return initialState;

        case permissionList?.CONFIGURATION_MANAGE: 
            initialState.isConfigurationManage = true;
            initialState.isConfigurationView = true;
            
            return initialState;
            
        case permissionList?.CUSTOMER_MANAGE: 
            initialState.isCustomerManage= true;
            initialState.isCustomerView= true;
            
            return initialState;

        case permissionList?.NOTIFICATION_MANAGE:
            initialState.isNotificationManage = true;
            initialState.isNotificationView = true;

            return initialState;

        case permissionList.NOTIFICATION_VIEW:
            initialState.isNotificationView = true;

            return initialState;

        case permissionList.TEMPLATE_MANAGE:
            initialState.isTemplateManage = true;
            initialState.isTemplateView = true;

            return initialState;


        case permissionList.TEMPLATE_VIEW:
            initialState.isTemplateView = true;
         
            return initialState;

        case permissionList.AUDIT_MANAGE:
            initialState.isAuditManage = true;
            initialState.isAuditView = true;

            return initialState;


        case permissionList.AUDIT_VIEW:
            initialState.isAuditView = true;
         
            return initialState;

        case permissionList?.LEAD_TEAM_MANAGE: 
            initialState.isLeadTeamManage = true;
            initialState.isLeadManage = true;
            initialState.isLeadView = true;

            return initialState;

        case permissionList?.ORDER_TEAM_MANAGE: 
            initialState.isOrderTeamManage = true;
            initialState.isOrderManage = true;
            initialState.isOrderView = true;

            return initialState;

        case permissionList?.INVOICE_TEAM_MANAGE: 
            initialState.isInvoiceView = true;
            initialState.isInvoiceManage = true;
            initialState.isInvoiceTeamManage = true;

            return initialState;

        case permissionList?.TASK_VIEW :
            initialState.isTaskView  = true;
            
            return initialState;

        case permissionList?.TASK_MANAGE: 
            initialState.isTaskManage = true;
            initialState.isTaskView = true;

            return initialState;

        case permissionList?.ALL_TASK_MANAGE: 
            initialState.isAllTaskManage = true;
            initialState.isTaskManage = true;
            initialState.isTaskView = true;

            return initialState;

        case permissionList?.TASK_TEAM_MANAGE: 
            initialState.isTaskTeamManage = true;
            initialState.isTaskManage = true;
            initialState.isTaskView = true;

            return initialState;
        
        case permissionList?.REPORT_VIEW:
            initialState.isReportView = true;
            return initialState;

        case permissionList?.REPORT_MANAGE:
            initialState.isReportView = true;
            initialState.isReportManage = true;
            return initialState;
            
        case permissionList?.WORKFLOW_VIEW:
            initialState.isWorkflowView = true;
            return initialState;
            
        case permissionList?.WORKFLOW_MANAGE:
            initialState.isWorkflowView = true;
            initialState.isWorkflowManage = true;
            return initialState;

        case permissionList?.AIML_MANAGE:
            initialState.isAimlManage = true;
            return initialState;
            
    }   
}


export const handleCheckPermission = async(userpermissionData) => {

    var initialState = {
        isDashboradView: false,
        isdashboardManage: false,
        isCustomerView: false,
        isCustomerManage: false,
        isProductView: false,
        isProductManage: false,
        isOrderView: false,
        isOrderManage: false,
        isConfigurationView: false,
        isConfigurationManage: false,
        isInvoiceView: false,
        isInvoiceManage: false,
        isInvoiceTeamManage: false,
        isLeadView: false,
        isLeadManage: false,
        isAllLeadManage:false,
        isLeadTeamManage:false,
        isAllInvoiceManage:false,
        isAllOrderManage:false,
        isOrderTeamManage:false,
        isVendorView: false,
        isVendorManage: false,
        isTemplateManage: false,
        isTemplateView: false,
        isNotificationView: false,
        isNotificationManage: false,
        isAuditView: false,
        isAuditManage: false,
        isReportView: false,
        isReportManage: false,
        isTaskView: false,
        isTaskManage: false,
        isAllTaskManage: false,
        isTaskTeamManage: false,
        isWorkflowView : false,
        isWorkflowManage : false,
        isAimlManage : false
    }
    
    
    await userpermissionData?.map(item => {
         handleCheckViewManage(item?.authority, initialState);
    })

    return initialState;
    
} 


export const renderRoutesBasedOnPermission = () => {
    
}

/**
 * Returns the default private route path for a user based on their rolebasedData permissions.
 * Evaluates view permission flags in priority order and returns the first allowed route.
 * Returns /biztantu/unauthorized if rolebasedData is null/empty or zero view permissions exist.
 */
export const getDefaultSelectedRoute = (rolebasedData) => {
    if (!rolebasedData) return privateRoutesPath.UNAUTHORIZED;
    if (rolebasedData.isDashboradView)     return privateRoutesPath.DASHBOARD;
    if (rolebasedData.isLeadView)          return privateRoutesPath.LEADS;
    if (rolebasedData.isCustomerView)      return privateRoutesPath.CUSTOMER;
    if (rolebasedData.isVendorView)        return privateRoutesPath.MERCHANT;
    if (rolebasedData.isProductView)       return privateRoutesPath.PRODUCT;
    if (rolebasedData.isOrderView)         return privateRoutesPath.ORDER;
    if (rolebasedData.isInvoiceView)       return privateRoutesPath.INVOICE;
    if (rolebasedData.isTaskView)          return privateRoutesPath.TASKS;
    if (rolebasedData.isReportView)        return privateRoutesPath.REPORTS;
    if (rolebasedData.isAuditView)         return privateRoutesPath.BIZTANTU_AUDIT;
    if (rolebasedData.isNotificationView)  return privateRoutesPath.BIZTANTU_TEMPLATE;
    if (rolebasedData.isWorkflowView)      return privateRoutesPath.WORKFLOW;
    if (rolebasedData.isConfigurationView) return privateRoutesPath.CONFIGURATION;
    return privateRoutesPath.UNAUTHORIZED;
};